import { Formik } from 'formik';
import { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import Button from 'components/_parts/atoms/button';
import LayoutModal from 'components/_parts/atoms/modal';
import Wrapper from 'components/_parts/atoms/wrapper';

import Tab from 'components/_parts/atoms/tab';
import {
  useCreateChildProcess,
  useCreateProcess, useCreateTreeProcess, useDetailprocess, useUpdateProcess, useWLATempalateSubmit,
  useWlaTemplateList,
} from 'components/businessProcess/api/useProcess';
import { mergeDetailProcess, mergeTreeProcess } from 'components/businessProcess/utils/mergedData';
import LoadingCustom from 'components/layouts/loading/loading';
import { bisnisProcess } from 'components/types/businessProcess';
import { useTranslation } from 'react-i18next';
import {
  UPDATE_LEVEL_PROCEESS_PARENT,
} from 'redux/actions/business_process';
import { DO_LOADING } from 'redux/actions/loading';
import { GET_WLA_LIST_TEMPLATE } from 'redux/actions/wla';
import { validationBp } from 'validation/BisnisProcess';
import CleanData from './parts/cleanData';
import { initialValues } from './parts/initialValues';
import LeftContent from './parts/leftContent';
import RightContent from './parts/rightContent';
import TabList from './parts/tabList';
import TitleBp from './parts/titleBp';

function ModalLayout({
  modal,
  setModal,
  typeModal,
  type,
  child,
  typeTree,
  datas,
}: bisnisProcess) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const boardId = localStorage.getItem('board_id');
  const processId = datas?.process_id || child?.process_id || '';

  const [tabValue, setTabValue] = useState(0);
  const tabList = TabList();

  // GET DATA
  const { data: detailProcess, isFetching: loaderProcess } = useDetailprocess(boardId, processId, (modal && Boolean(processId)));

  const { data: wlaTemplateList = [], isFetching: loaderWlaTemplate } = useWlaTemplateList(processId, (modal && Boolean(processId)));

  const isLoadingModal = loaderProcess || loaderWlaTemplate;

  // MUTATION
  const { mutateAsync: createProcess } = useCreateProcess();
  const { mutateAsync: createTreeProcess } = useCreateTreeProcess();
  const { mutateAsync: createChildProcess } = useCreateChildProcess();
  const { mutateAsync: updateProcess } = useUpdateProcess();
  const { mutateAsync: wlaSubmit } = useWLATempalateSubmit();

  const initialValuesState = useMemo(() => {
    const isTreeAction = ['add_next', 'add_previous', 'add_child'].includes(typeTree);

    if (isLoadingModal) return initialValues;

    if (typeTree === 'update_process') {
      return mergeDetailProcess(detailProcess, wlaTemplateList, typeModal);
    } if (isTreeAction) {
      return mergeTreeProcess(detailProcess, typeTree);
    }
    return initialValues;
  }, [detailProcess, wlaTemplateList, isLoadingModal, typeTree]);

  const isTree = ['add_next', 'add_previous'];

  const handleSubmit = async (values) => {
    dispatch({ type: DO_LOADING, payload: true });
    setModal(false);

    const {
      data, dataChild, dataTree, dataEdit,
    } = CleanData({
      values,
      child,
      typeTree,
      typeModal,
    });
    try {
      let processId = null;

      if (datas !== undefined) {
        await updateProcess(dataEdit);
        processId = dataEdit.process_id;
      } else if (typeTree === undefined && values.level === 1
      ) {
        const dataResponse = await createProcess(data);
        processId = dataResponse.data.process_id;
      } else if (isTree.includes(typeTree) && child !== undefined) {
        const dataResponse = await createTreeProcess(dataTree);
        processId = dataResponse.data.new_process_id;
      } else {
        const dataResponse = await createChildProcess(dataChild);
        processId = dataResponse.data.process_id;
      }

      if (processId) {
        const WlaPayload = {
          data_form: values.dataWorkload,
          process_id: processId,
        };
        await wlaSubmit(WlaPayload);
      }
    } catch (error) {
      setModal(false);
    } finally {
      dispatch({ type: DO_LOADING, payload: false });
    }
  };

  const handleClear = () => {
    dispatch({
      type: GET_WLA_LIST_TEMPLATE,
      payload: [],
    });
    dispatch({
      type: UPDATE_LEVEL_PROCEESS_PARENT,
      payload: 1,
    });
  };

  const contentBP = (values) => {
    switch (tabValue) {
      case 1:
        return (
          <RightContent
            paramTab={tabValue}
            typeTree={typeTree}
            type={type}
            t={t}
          />
        );

      default:
        return (
          <LeftContent
            typeTree={typeTree}
            t={t}
          />
        );
    }
  };

  return (
    <LayoutModal type="bispro_revamp" modal={modal}>
      <Wrapper
        setModal={setModal}
        handleClear={handleClear}
        style={{ height: '100%', padding: '30px 45px' }}
      >
        <Formik
          initialValues={initialValuesState}
          validationSchema={validationBp({ t })}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({ values, handleSubmit }) => (
            <form
              className="custom_layout_create"
              style={{ position: 'relative' }}
              onSubmit={handleSubmit}
            >
              <TitleBp
                child={child}
                typeModal={typeModal}
                typeTree={typeTree}
                datas={values}
                t={t}
                parentLevel={values.level}
              />
              <div className="mx-auto tw-mt-[5px]">
                <Tab
                  data={tabList}
                  tab={tabValue}
                  setTab={setTabValue}
                  className="tab_title-sm !tw-mb-0"
                />
              </div>
              {isLoadingModal
                ? <LoadingCustom />
                : contentBP(values)}
              <div className="button_library-position">
                <Button
                  style={{
                    backgroundColor: 'transparent',
                    color: '#3D5AFE',
                    width: '90px',
                    height: '40px',
                    marginLeft: 'auto',
                  }}
                  func={() => {
                    setModal(false);
                    handleClear();
                  }}
                >
                  {t('biz_process.cancel')}
                </Button>
                <Button
                  style={{ width: '90px', height: '40px' }}
                  func={handleSubmit}
                >
                  {t('biz_process.save')}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Wrapper>
    </LayoutModal>
  );
}

export default ModalLayout;
